import qs from 'qs'
const sensors = require('sa-sdk-javascript')

interface Dict {
  [k: string]: string
}

const EnterPage: Dict = {
  quick: '快速入口',
  record: '笔记页面',
  matter: '事项笔记',
  meeting: '会议笔记',
}

const { env, platform_type, client_version, enterPage, userId, os } = qs.parse(
  window.location.search.substr(1)
) as {
  env: 'release' | 'prod'
  platform_type: string
  client_version: string
  enterPage: string
  userId: string
  os: string
}

window.localStorage.setItem('enterPage', enterPage)
window.localStorage.setItem('userId', userId)

interface IParams {
  notes_id: string
  has_title: boolean
  has_detail: boolean
  // has_file: boolean
  // has_related_issue: boolean
  // is_quote: boolean
}

function checkInvalid() {
  return !enterPage || !userId || !platform_type || !client_version
}

function init() {
  if (checkInvalid()) return

  const dict = {
    release: 'https://datasink.flyele.net:8443/sa?project=default',
    prod: 'https://datasink.flyele.net:8443/sa?project=production',
  }

  console.log('sensor init')

  sensors.init({
    server_url: dict[env],
    is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    use_client_time: true,
    send_type: 'beacon',
    heatmap: {
      // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'not_collect',
      // 是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'not_collect',
      get_vtrack_config: false,
    },
    show_log: true,
  })

  sensors.registerPage({
    platform_type,
    client_version: client_version,
    os,
  })

  sensors.login(userId)
}

const sensorSendCreateDiary = (p: IParams) => {
  if (checkInvalid()) return

  console.log('send sensor')

  sensors.track('create_notes_success', {
    enter_create_notes_page: EnterPage[enterPage],
    ...p,
  })
}

export { sensorSendCreateDiary, init }
